import { PERMISSIONS } from '@shared/permissions/permissions';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Table2 } from 'lucide-react';

// Pass-through layout carrying the access gates for the whole registers tree.
// Route metadata is merged across matched routes, so the flag + permission here
// hide the left-nav item and gate every child path (RouteAccessGuard renders
// NotFound on deep links while `enable-registers` is off).
export const Route = createFileRoute('/console/$orgId/compliance/registers')({
    staticData: {
        breadcrumb: { title: 'Registers' },
        featureFlag: 'enable-registers',
        permissions: [PERMISSIONS.REGISTER_READ],
        ui: { icon: Table2 },
    },
    component: Outlet,
});
